import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Img from "gatsby-image"
import SEO from "../components/seo"
import ImagesAtelier from "../components/imagesAtelier"

export const query = graphql`
  query($slug: String!) {
    contentfulAtelier(slug: { eq: $slug }) {
      titre
      champLibre
      description {
        description
      }
      couverture {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image1 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image2 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image3 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image4 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image5 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image6 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image7 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image8 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image9 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image10 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image11 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image12 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image13 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image14 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image15 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image16 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image17 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image18 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
      image19 {
        fluid(quality: 90) {
          ...GatsbyContentfulFluid_withWebp_noBase64
        }
      }
    }
  }
`

const Atelier = ({ data }) => {
  return (
    <Layout>
      <SEO title={data.contentfulAtelier.titre} />
      <section className="section__content --grid">
        <div className="projet">
          <div className="grid__projet --two">
            {data.contentfulAtelier.image1 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image1.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image2 && (
              <div className="grid__item paysage">
                <Img fluid={data.contentfulAtelier.image2.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --content">
            <div className="grid__item">
              {data.contentfulAtelier.champLibre && (
                <div>{data.contentfulAtelier.champLibre}</div>
              )}
            </div>
            <div className="grid__item">
              <h1>{data.contentfulAtelier.titre}</h1>
            </div>
            <div className="grid__item">
              {data.contentfulAtelier.description && (
                <p>{data.contentfulAtelier.description.description}</p>
              )}
            </div>
          </div>
          <div className="grid__projet --two">
            {data.contentfulAtelier.image3 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image3.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image4 && (
              <div className="grid__item paysage">
                <Img fluid={data.contentfulAtelier.image4.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --three">
            {data.contentfulAtelier.image5 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image5.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image6 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image6.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image7 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image7.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --two">
            {data.contentfulAtelier.image8 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image8.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image9 && (
              <div className="grid__item paysage">
                <Img fluid={data.contentfulAtelier.image9.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --three">
            {data.contentfulAtelier.image10 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image10.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image11 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image11.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image12 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image12.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --two">
            {data.contentfulAtelier.image13 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image13.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image14 && (
              <div className="grid__item paysage">
                <Img fluid={data.contentfulAtelier.image14.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --three">
            {data.contentfulAtelier.image15 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image15.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image16 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image16.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image17 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image17.fluid} />
              </div>
            )}
          </div>
          <div className="grid__projet --two">
            {data.contentfulAtelier.image18 && (
              <div className="grid__item">
                <Img fluid={data.contentfulAtelier.image18.fluid} />
              </div>
            )}
            {data.contentfulAtelier.image19 && (
              <div className="grid__item paysage">
                <Img fluid={data.contentfulAtelier.image19.fluid} />
              </div>
            )}
          </div>
        </div>
        <div className="block__bottom --specialMargin">
          <ImagesAtelier getOnlyFourItems={false} />
        </div>
      </section>
    </Layout>
  )
}

export default Atelier
